const ko = {
  general: {
    position: 'Position',
    updateSuccess: 'Update successful!',
    editProfileImg: 'Edit Profile Picture',
    editCoverImg: 'Edit Cover Picture',
    register: 'Sign Up',
    login: 'Log In',
    date: 'Date',
    export: 'Export',
    or: 'or',
    end: 'End',
    confirmEmail: 'Confirm Email',
    password: 'Password',
    forgetPassword: 'Forgot password?',
    changePassword: 'Change password',
    confirmPassword: 'Confirm Password',
    knownAs: 'Known as',
    oldPassword: 'Old password',
    newPassword: 'New password',
    minLength: 'Minimum length is {n}',
    unmatched: '{col} does not match.',
    chooseAnotherAccount: 'Log in with another account',
    confirmNewPassword: 'Confirm new password',
    required: 'Field required.',
    country: 'Country',
    new: 'NEW',
    username: 'User Name',
    category: 'Category'
  },
  editPhoto: '사진 편집',
  deletePhoto: '사진 삭제',
  changePhoto: '사진 변경',
  savePhoto: '사진 저장',
  livetour: '쇼룸',
  country: {
    JP: 'Japan',
    KR: 'Korea',
    HK: 'Hong Kong and Macau',
    SG: 'Singapore',
    MY: 'Malaysia',
    TH: 'Thailand',
    VN: 'Vietnam',
    ID: 'Indonesia',
    PH: 'Philippines',
    EU: 'Europe',
    NA: 'North America',
    NZ: 'New Zealand and Australia',
    TW: 'Taiwan'
  },
  vrlounge: {
    ticketNotOnboardHint: 'Please enter the online virtual exhibition after onboarding the ticket at the physical exhibition.',
    cannotChangeAfterSubmit: 'Cannot change after submit',
    hintLogin: 'If you’ve registered with your ticket number, please click “Log In” to log in by your email.',
    lounge: 'VR Lounge',
    networking: 'Networking',
    profile: '프로필',
    peopleOnline: 'People Online',
    totalVisitors: 'Total Visitors',
    connect: 'Connect',
    waitConfirmed: 'Wait to be confirmed',
    isConfirmed: 'CONFIRMED',
    confirm: 'CONFIRM',
    reject: 'REJECT',
    confirmReject: 'Are you sure you would like to reject?',
    hintReject: 'This cannot be canceled',
    thinkTwice: 'Let me think twice',
    rejectInvitation: 'Reject invitation',
    connectSuccess: 'Connect Success!',
    block: 'Block',
    visitor: 'Visitor',
    exhibitor: 'Exhibitor',
    invitationTitle: 'Personalized Invitation Message',
    invitationPlaceholder: 'Hello! Hope to connect with you! (at most 1000 characters)',
    noTicketRecord: 'No ticket record. Please purchase a ticket.',
    invalidTicket: 'Invalid ticket',
    enterTicket: 'Please enter your ticket number',
    sent: 'Sent',
    received: 'Received',
    connected: 'Connected',
    agreeToContinue: 'You must agree to the Terms & Conditions and Privacy Policy to continue.',
    ticketUsed: 'This ticket has been used.',
    passwordRule: 'The password must contain 8 characters, at least one letter and one number.',
    cardExchange: 'The visitor wants to exchange business cards with you, please confirm whether to accept or reject the exchange.',
    loginToAccount: 'Log in to your account',
    keepLogin: 'Keep me logged in',
    cantLogin: 'Can’t log in? Click ',
    here: 'here',
    allRole: 'All role',
    sortNameAtoZ: 'Name (A→Z)',
    sortNameZtoA: 'Name (Z→A)',
    onlineNewToOld: 'Last Login Time (Latest)',
    onlineOldToNew: 'Last Login Time (Earliest)',
    exhibitorFirst: 'Exhibitor First',
    visitorFirst: 'Visitor First',
    inviteTimeNewToOld: 'Invite Time (Latest)',
    inviteTimeOldToNew: 'Invite Time (Earliest)',
    basicInfo: 'Basic Info',
    contact: 'Contact',
    contactInfo: '연락처 정보',
    state: 'State',
    sentRequest: 'Send Request',
    haveNotConfirmed: 'You haven’t confirmed yet',
    message: 'Message',
    sendMessageTo: 'Message'
  },
  sort: '분류',
  filter: '필터',
  test: '테스트',
  apply: '적용',
  all: '전체',
  livingroom: '거실',
  diningroom: '주방',
  kitchen: '주방',
  bedroom: '침실',
  study: '공부',
  bathroom: '욕실',
  toilet: '화장실',
  garden: '정원',
  garage: '주차장',
  outdoors: '실외',
  others: '기타',
  vrTooltip: 'VR 모드는 모바일 기기에서만 사용가능합니다',
  vrInstructions: '',
  send: '전송',
  scanQrCode: 'QR 코드를 스캔하여 가상 투어',
  logOut: '로그아웃',
  postAsAnonymous: '익명으로 게시',
  loginGoogle: 'Google+ 계정으로 로그인',
  loginFacebook: '\bFacebook 계정으로 로그인',
  postComment: '댓글을 남겨주세요',
  selectAction: '선택해주세요',
  noBuilding: '죄송합니다.',
  browserNoSupport: '<h3>죄송합니다.',
  webGlNoSupport: 'WebGL 컨텍스트를 가져오는 데 실패했습니다. 브라우저 또는 장치가 WebGL을 지원하지 않을 수 있습니다.',
  urlNoSupportIFrameError: '이 링크가 만료되었거나 페이지에서 외부 임베디드 링크를 허용하지 않습니다.',
  noPanoramas: '죄송합니다！ 파노라마가 존재하지 않습니다.',
  buildingNotFound: '<h3>링크가 존재하지 않습니다.</h3><p> 라이브 투어를 찾을 수 없습니다..</p><a href="https://www.twmsolution.com/">다른 라이브투어 보기</a>',
  buildingNotInPropertyRedirect: '<h3>죄송합니다! 라이브투어가 삭제되었습니다.</h3><p>목록의 첫 번째 라이브 투어로 리디렉션......</p>.',
  information: '정보',
  panoSelect: '파노라마',
  floorplan: '평면도',
  qrCode: 'QR 코드',
  music: '음악',
  openMusic: '배경 음악 켜기',
  closeMusic: '배경 음악 꺼 줘',
  gyro: 'Gyro',
  vrmode: 'VR 모드',
  fullscreen: '전체화면',
  like: '좋아요',
  comment: '댓글',
  propertyInfo: '그룹 정보',
  buildingInfo: '라이브투어 정보',
  buyNow: '지금 구매하기',
  viewAtHome: 'AR로 보기',
  learnMore: '더 알아보기',
  contactSupplier: '공급업체에 문의하기',
  memo: '메모',
  location: '위치',
  promotionText: '손쉬운 가상 투어 >',
  promotionLinkText: '5달러로 시작하기',
  close: '닫기',
  addComment: '댓글 추가',
  share: '공유하기',
  leaveInfoContinue: '이 라이브투어를 보기위해 당신의 정보를 입력하세요',
  company: '회사',
  companyName: '회사명',
  name: '성명',
  firstName: '이름',
  lastName: '성',
  email: '이메일',
  phone: '휴대폰 번호',
  occupation: '직업',
  emailFormatInvalid: '유효하지 않은 이메일 형식입니다.',
  duplicateEmail: '중복된 이메일',
  privacyPolicy: '개인정보 취급방침',
  userTerms: '이용 약관 및 조건',
  visitorLogin: '계정이 있으신가요?',
  visitorAgreement1: '당신의 개인 정보를 저희에게 제출함으로써 당사에는 매우 중요한 사항합니다. ',
  visitorAgreement2: '{company}에 전화를 걸 수 있도록 승인합니다.',
  visitorAgreement: '<a href="https://www.istaging.com/legal/terms_of_service" target="_blank">이용 약관</a>& <a href="https://www.istaging.com/legal/privacy_policy" target="_blank">개인정보 처리방침</a> 에 동의합니다 .',
  visitorLeaveDataReason: '연락처 정보를 제출해주세요~ 가상 체험에 오신 것을 환영합니다!',
  visitorAgreePolicy: '가상 경험의 소유자는 이메일이나 전화로 저에게 연락할 수 있습니다!',
  visitorCheckTheEmail: '거의 다 왔습니다!<br> 받은 편지함으로 이동하여 수신한 링크를 클릭하여 이메일을 확인해주세요!<br>가상 체험에 한 걸음 더 가까이 다가갈 수 있게 되었습니다!',
  visitorEnterAccessKey: '이메일로 받은 액세스 코드를 입력하세요. 받지 못했다면 스팸 폴더를 확인하세요.',
  accessCode: '액세스 코드',
  accessCodeError: '액세스 코드 에러',
  receiveEmailVerification: '이메일을 통해 액세스 코드를 받으세요.',
  verify: '인증',
  back: '뒤로가기',
  welcomeToLiveTour: '<strong>라이브투어</strong>에 오신 걸 환영합니다!',
  resend: '재전송',
  invalidAccessCode: '액세스 코드가 올바르지 않습니다.',
  resendCodeError: '액세스 코드 재전송에 실패했습니다.',
  website: '웹사이트',
  cardMore: '더보기',
  clickNavigate: '탐색',
  showMore: '더보기',
  searchTag: '태그 탐색',
  somethingWrong: '<h3>죄송힙니다.. 문제가 발생했습니다...</h3><a href="https://www.istaging.com/en/contact">알 수 없는 문제 신고하기</a>',
  GuidedTour: '가이드투어',
  ClientWelcome: '환영합니다!',
  ClientFormHint: '"지금 통화하기"를 클릭하여',
  ClientFormWelcomeText: '다음 정보를 입력하고 "지금 통화하기"를 클릭합니다.<br> 상담원이 온라인으로 안내해 드립니다.<br>헤드셋과 마이크를 연결하고, 네트워크 연결 상태가 양호한지 체크해주세요!',
  ClientWelcomeNamePhoneHint: '이름과 전화번호를 입력하세요.',
  ClientWelcomeNameHint: '이름을 입력하세요.',
  ClientWelcomePhoneHint: '전화번호를 잘못 입력했거나 형식이 올바르지 않습니다.',
  ClientWelcomeLanguage: '언어',
  ClientWelcomeLanguageDesc: '투어 가이드 언어를 선택하세요.',
  ClientWelcomeLanguageHint: '언어를 선택해주세요.',
  FieldRequired: '*필수 항목',
  ClientFormCallNow: '지금 전화하기',
  None: '없음',
  Agent: '상담원',
  RememberMe: '나를 기억해 주세요',
  TheFieldIsRequired: '*필수 항목',
  IncorrectFormat: '잘못된 형식',
  YouMustAgreeLicense: '위에서 언급된 약관에 동의해야 합니다.',
  Submit: '제출',
  BuildingNonPublicInfo: '이 라이브투어는 보이지 않게 숨겨져 있습니다.',
  WebRTCNotSupportTitle: '브라우저에서 지원하지 않는 항목',
  WebRTCNotSupportDesc: '페이지 URL을 복사하여 Google Chrome에 붙여넣기',
  WebRTCNotSupportDesciOS: '페이지 URL을 복사하여 Safari에 붙여넣기',
  WebRTCNotSupportDescAndroid: '페이지 URL을 복사하여 Chrome 또는 Firefox에 붙여넣기',
  WebRTCNotSupportCopyButton: '한 번의 클릭으로 복사하기',
  Copied: '복사 완료',
  search: '검색',
  searchContent: '콘텐츠 검색',
  noResult: '검색 결과 없음',
  searchResult: '검색 결과 없음',
  relatedResult: '관련 검색 결과',
  scaleUp: '확대',
  scaleDown: '축소',
  viewIn3D: '3D로 보기',
  unableJoinMeeting: '모임에 참가할 수 없음',
  invalidMeetingId: '유효하지 않은 회의 ID 입니다.',
  unableAccessMediaDevice: '브라우저가 카메라/마이크에 대한 액세스를 차단하고 있습니다.',
  connectingMeeting: '회의을 주최하려고 합니다.',
  meetingNotStartedYet: '회의에 참가할 수 없습니다. 아직 시작되지 않았습니다. 호스트를 기다리려면 클릭하세요.',
  joinedMeeting: '회의에 참석 중입니다.',
  joiningMeeting: '회의에 참여하려고 합니다.',
  repeatJoinWarning: '재가입하는 경우',
  meetingIsOver: '회의가 끝났습니다.',
  startAnotherMeeting: '다른 회의를 시작하려면 편집기로 이동하세요.',
  closeMeeting: '닫기',
  joinMeeting: '회의 참여',
  leaveMeeting: '떠나기',
  remainTime: '잔여 시간',
  meetingIsFull: '회의가 꽉 찼습니다.',
  connectionFail: '연결 실패',
  unableConnectMeeting: '회의에 참가할 수 없음',
  joinMeetingFail: '회의 참여 실패',
  aboutEndMeeting: '이 회의가 곧 종료됩니다.',
  aboutLeaveMeeting: '이 회의을 종료하려고 합니다.',
  endedMeeting: '이 회의는 종료되었습니다.',
  meetingRedirect: '라이브 투어로 이동합니다.',
  leftMeeting: '이 미팅에서 나갔습니다.',
  waitMeeting: '진행자가 회의실을 나갔다가 다시 연결되면 미팅을 재개합니다. 5분 이내에 연결되지 않으면 미팅이 종료됩니다.',
  disconnectMeeting: '연결이 끊어졌습니다. 5분 이내에 다시 연결하고 페이지를 새로 고침하여 회의로 돌아가세요.',
  copyLink: '복사 링크',
  copySuccess: '복사 완료',
  confirm: 'OK',
  cancel: '취소',
  IMServe: '즉각적인 고객 서비스',
  product: '제품',
  pilot: '파일럿',
  pilotBooking: '투어를 예약하다',
  pilotStop: '파일럿 중지',
  pilotTours: '투어',
  pilotPopularTours: '인기있는 투어',
  pilotInfluencerList: '투어 가이드 목록',
  pilotTourBy: '{influencer} 별 투어',
  PilotDescription: '설명',
  PilotDetailedInformation: '세부 정보',
  pilotSwitchTourNotice: '현재 "{pilot1}"을 재생 중입니다.<br>"{pilot2}"를 시작하시겠습니까?',
  pilotSameTourNotice: '현재 "{pilot1}"을 재생 중입니다.<br>처음부터 시작하시겠습니까?',
  pilotPlayerPopupButtonYes: '네',
  pilotRecorderStart: '시작하려면 여기를 클릭하세요.',
  pilotRecorderStop: '멈추려면 여기를 클릭하세요.',
  pilotRecorderUploading: '업로드 중...',
  pilotRecorderUploadFailed: '업로드 실패',
  pilotRecorderPopupTitleNotice: '공지사항',
  pilotRecorderPopupTitleComplete: '기록 완료',
  pilotRecorderPopupTitleError: '에러!',
  pilotRecorderPopupTextNotice: '• 녹음 시간은 10분으로 제한됩니다.<br> •  시스템에서 마이크에 액세스할 수 있도록 허용해 주세요.',
  pilotRecorderPopupTextComplete: '챕터가 완료되었습니다.<br>VR 에디터에서 검토해 주세요.',
  pilotRecorderPopupTextRelogin: '다시 로그인해야 합니다.',
  pilotRecorderPopupTextError: '브라우저에서 마이크 사용 권한을 확인하세요.',
  pilotRecorderPopupButtonOK: 'OK',
  pilotRecorderRemainTimeWarning: '10분의 녹음 시간이 곧 종료됩니다. 녹음을 완료해 주세요.',
  pilotTooltipTitle: '미리 알림',
  pilotTooltipConfirm: '그렇군요! 시작해보세요!',
  pilotTooltipCancel: '투어 건너뛰기',
  selectPilot: '파일럿 선택하기',
  pilotInfluencer: '파일럿 인플루언서',
  pilotChaptersTitle: '챕터 경로 설정(듣기 선택)',
  pilotReadMoreBtnLabel: '콘텐츠 전체 보기',
  pilotSelfBrowsingModeMessageTitle: '셀프 브라우징 모드 이용',
  pilotSelfBrowsingModeMessageContent: "언제든지 '켜기'를 클릭하여 둘러보기 모드로 돌아갈 수 있습니다.",
  pilotReplay: '재생하기',
  pilotPrevious: '이전',
  pilotNext: '다음',
  pilotPause: '정지',
  pilotPlay: '시작',
  pilotTurnOnSelfBrowsingMode: '투어 모드 끄기',
  pilotTurnOffSelfBrowsingMode: '투어 모드 켜기',
  uploadImage: '이미지 업로드',
  booking: {
    calendar: 'Calendar',
    reserve: 'Reserve',
    dateSelectTitle: 'Choose a time that works for you.',
    backToSelect: 'Choose a different time',
    requiredField: 'This is a required field',
    timeRange: 'Time range',
    fieldMessage: 'Message',
    confirm: 'Confirm Booking',
    pleaseWait: 'Please wait...',
    submitError: 'An error occurred while sending the request: ',
    reserveSuccess: 'Booking Successful',
    thanksUser: 'Thanks,',
    confirmingEmail: "You'll receive a notification confirming the meeting details shortly.",
    emailEmptyHint: 'Email is empty.'
  },
  favorites: {
    title: '내가 제일 좋아하는',
    add: 'Add to favorites',
    remove: 'Remove from favorites',
    category: {
      marker: 'Product',
      panorama: 'Showroom',
      company: 'Company',
      card: 'Business card'
    },
    table: {
      image: {
        company: 'Logo',
        marker: 'Product image',
        card: 'Avatar'
      },
      name: {
        company: 'Company name',
        marker: 'Product name',
        card: 'Name'
      },
      description: {
        company: 'Company description',
        marker: 'Product description'
      },
      type: 'Type',
      note: 'Note',
      company: 'Company',
      occupation: 'Occupation',
      listEmpty: 'Nothing yet'
    },
    note: {
      empty: 'Enter a note...(Up to {n} letters)',
      saved: 'Saved!'
    },
    pdf: {
      export: 'Export as PDF',
      exporting: 'Exporting...',
      note: 'Note: ',
      pager: 'Page {page} of {total}'
    }
  },
  video360: {
    notAvailable: 'The video is not available in your country.'
  },
  utils: {
    more: 'Show More',
    less: 'Show Less'
  },
  introAssets: {
    enter: 'Enter'
  },
  Authorize: '권한 부여',
  AuthorizeRequired: '승인 필요',
  AuthorizeInMicrosoft: 'Microsoft에서 이 앱 인증',
  agreeNonDisclosureAgreement: '"승인"을 클릭하면 동의됩니다',
  clickAuthorizeToAgree: '"승인"을 클릭하면 동의됩니다',
  nonDisclosureAgreement: '비공개 동의',
  AuthorizeAccept: '동의',
  accessLiveTourSteps: '투어 라이브투어에 접속하는 3단계',
  NDA: '기밀 유지 계약',
  productUnavailable: '이 상품은 판매 중단되었습니다.',
  whiteList: {
    login: 'Sign In to Explore!',
    error: '* Invalid account or password! Please try again.',
    warnTitle: 'Authentication Failed',
    warnContent: 'Your username does not exist in the authorized list, please try again or contact the administrator.'
  },
  instantMessaging: {
    quickQA: 'Quick Q&A',
    mediaMessage: 'Shared a file',
    locationMessage: 'Shared a file',
    startConversation: 'Start a conversation with the organizer in this exhibition area!'
  },
  noSearchResult: '데이터를 찾을 수 없습니다.',
  tourring: {
    host: 'Host',
    noAnswer: 'Your contact is currently unable to answer.',
    noPushId: 'Your contact is currently unavailable.',
    busy: 'Your contact is busy with a guided tour.',
    response: 'Please refer to the reservation calendar.',
    goToReserve: 'Access to the calendar',
    dialing: 'Dialing',
    dialingHint: "After you're connected, it will open a new tab",
    handupPhoneHint: 'Your call is not connected yet,',
    handupPhoneHint2: 'Please confirm whether or not to hang up.'
  },
  otherFunctions: '다른 기능',
  returnToFirstPanorama: '첫 번째 파노라마로 돌아가기',
  cookieBannerContent: 'We use cookies to enhance your browsing experience, serve personalized ads or content. By forwarding of viewing the website, you consent to our use of cookies. Please check',
  cookieBannerContentLinkAfter: 'for detail.',
  cookieBannerPolicyLinkText: 'Privacy Statement',
  cookieBannerButtonText: 'Accept'
}

export default ko
